export var CommenceOperationContent;
(function (CommenceOperationContent) {
    CommenceOperationContent["Alongside"] = "alongside";
    CommenceOperationContent["Fastened"] = "Fastened";
    CommenceOperationContent["HoseCon"] = "Hose con.";
    CommenceOperationContent["StartPumping"] = "Start pumping";
})(CommenceOperationContent || (CommenceOperationContent = {}));
//# sourceMappingURL=CommenceOperationContent.js.map